// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pIeyA0fzX6 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.pIeyA0fzX6 h4 {
  line-height: 3em;
}
.pIeyA0fzX6 .J7eLd4YZgu {
  float: left;
  width: 100%;
}
.pIeyA0fzX6 .gjqF_OYue0 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.pIeyA0fzX6 .gjqF_OYue0:hover {
  cursor: pointer;
}
.pIeyA0fzX6 .gjqF_OYue0:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.B8PpWw0Z0t .DLCW2zMINC:focus {
  outline: none;
}
.B8PpWw0Z0t .DLCW2zMINC.VgKVHXU_QR.oJ3YqTkEYJ {
  background: #375A88;
}
.B8PpWw0Z0t .DLCW2zMINC.VgKVHXU_QR.oJ3YqTkEYJ span {
  color: #fff;
}
.B8PpWw0Z0t .oJ3YqTkEYJ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.B8PpWw0Z0t .oJ3YqTkEYJ:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.B8PpWw0Z0t input {
  height: 38px;
  min-width: 220px;
}
.gjqF_OYue0.vSOavApJNN {
  background: #410102;
}
.gjqF_OYue0.cb_Qj0u0HA {
  background: #911318;
}
.gjqF_OYue0.H_SFdvZzY6 {
  background: #D8293B;
}
.gjqF_OYue0.hUXUWqofKV {
  background: #F2373C;
}
.gjqF_OYue0.y6QkY1RWSl {
  background: #FC4448;
}
.gjqF_OYue0._YImj8KaMb {
  background: #ED535E;
}
.gjqF_OYue0.xUIMx2EwPt {
  background: #E34926;
}
.gjqF_OYue0.WdIy9tABmv {
  background: #FC562B;
}
.gjqF_OYue0.DCKa2vavww {
  background: #FC6722;
}
.gjqF_OYue0.YjcmUD_3Lz {
  background: #FD7F24;
}
.gjqF_OYue0.V4ceDCz9Sb {
  background: #FD8D26;
}
.gjqF_OYue0.kwAqSz6lpn {
  background: #EC9C3E;
}
.gjqF_OYue0.JXPpgejHH0 {
  background: #0e673a;
}
.gjqF_OYue0.FA2oaPkqN_ {
  background: #208740;
}
.gjqF_OYue0.tjyEEQUN6n {
  background: #239718;
}
.gjqF_OYue0.oz0WjdXR9m {
  background: #55A84D;
}
.gjqF_OYue0.dbt49dnpgd {
  background: #4BBE5A;
}
.gjqF_OYue0.tSrXbqxp0i {
  background: #0CCA6A;
}
.gjqF_OYue0.vr5YxF7ttv {
  background: #0A3C64;
}
.gjqF_OYue0.ou5NbwDoOn {
  background: #0d487a;
}
.gjqF_OYue0.cjzT1yqIj7 {
  background: #10538d;
}
.gjqF_OYue0.Rw_Fmqjnq0 {
  background: #115A99;
}
.gjqF_OYue0.iQqLCH3CMz {
  background: #3387E2;
}
.gjqF_OYue0.IRfuyU7Yv7 {
  background: #1BA9CF;
}
.gjqF_OYue0._ySGYaFRww {
  background: #d27c02;
}
.gjqF_OYue0.jH5NBuVvhw {
  background: #fb9402;
}
.gjqF_OYue0.xYWieOa2aD {
  background: #FD9B30;
}
.gjqF_OYue0.htq4H7ZqZH {
  background: #FDBE2D;
}
.gjqF_OYue0.lAsO6YcOP7 {
  background: #FED831;
}
.gjqF_OYue0.bdFgwwLVlX {
  background: #FFFD38;
}
.gjqF_OYue0.hPlOqlbFOT {
  background: #2D215C;
}
.gjqF_OYue0.mn4SQk5OFB {
  background: #483C83;
}
.gjqF_OYue0.QkkNzQiNT7 {
  background: #58518d;
}
.gjqF_OYue0.IsG0mdO2SU {
  background: #7068A9;
}
.gjqF_OYue0.rsyhW9gdA0 {
  background: #7f78b2;
}
.gjqF_OYue0.du7hi7ZwFA {
  background: #8f88bc;
}
.gjqF_OYue0.fRkKUgX6VP {
  background: #000;
}
.gjqF_OYue0.df8ngAhNdE {
  background: #282626;
}
.gjqF_OYue0.QvXCwhKjTK {
  background: #242222;
}
.gjqF_OYue0.KRnbkeGVlY {
  background: #353838;
}
.gjqF_OYue0.cZJJIsAoa6 {
  background: #666;
}
.gjqF_OYue0.vMY90Sfczy {
  background: #999;
}
.GAwZNJkHZ3 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.GAwZNJkHZ3 .X8y0e6qDnJ {
  display: none;
}
.aIyvNsTiqT .GG9OuxfbGm {
  line-height: 15px;
  margin-bottom: 12px;
}
.aIyvNsTiqT .IUAuuOKuxO {
  min-width: 800px;
  padding: 28px 36px 38px;
  width: 100%;
}
.aIyvNsTiqT .oTQkrBtGmX {
  width: 728px;
}
.aIyvNsTiqT .XRzrAwLA_h,
.aIyvNsTiqT .XRzrAwLA_h {
  background: none;
}
.aIyvNsTiqT .XRzrAwLA_h > div:first-child,
.aIyvNsTiqT .XRzrAwLA_h > div:first-child {
  font-size: 11px;
  font-style: normal;
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `pIeyA0fzX6`,
	"color-row": `J7eLd4YZgu`,
	"color-tile": `gjqF_OYue0`,
	"picker-component": `B8PpWw0Z0t`,
	"picker-element": `DLCW2zMINC`,
	"active": `VgKVHXU_QR`,
	"btn": `oJ3YqTkEYJ`,
	"red-1": `vSOavApJNN`,
	"red-2": `cb_Qj0u0HA`,
	"red-3": `H_SFdvZzY6`,
	"red-4": `hUXUWqofKV`,
	"red-5": `y6QkY1RWSl`,
	"red-6": `_YImj8KaMb`,
	"orange-1": `xUIMx2EwPt`,
	"orange-2": `WdIy9tABmv`,
	"orange-3": `DCKa2vavww`,
	"orange-4": `YjcmUD_3Lz`,
	"orange-5": `V4ceDCz9Sb`,
	"orange-6": `kwAqSz6lpn`,
	"green-1": `JXPpgejHH0`,
	"green-2": `FA2oaPkqN_`,
	"green-3": `tjyEEQUN6n`,
	"green-4": `oz0WjdXR9m`,
	"green-5": `dbt49dnpgd`,
	"green-6": `tSrXbqxp0i`,
	"blue-1": `vr5YxF7ttv`,
	"blue-2": `ou5NbwDoOn`,
	"blue-3": `cjzT1yqIj7`,
	"blue-4": `Rw_Fmqjnq0`,
	"blue-5": `iQqLCH3CMz`,
	"blue-6": `IRfuyU7Yv7`,
	"yellow-1": `_ySGYaFRww`,
	"yellow-2": `jH5NBuVvhw`,
	"yellow-3": `xYWieOa2aD`,
	"yellow-4": `htq4H7ZqZH`,
	"yellow-5": `lAsO6YcOP7`,
	"yellow-6": `bdFgwwLVlX`,
	"purple-1": `hPlOqlbFOT`,
	"purple-2": `mn4SQk5OFB`,
	"purple-3": `QkkNzQiNT7`,
	"purple-4": `IsG0mdO2SU`,
	"purple-5": `rsyhW9gdA0`,
	"purple-6": `du7hi7ZwFA`,
	"black-1": `fRkKUgX6VP`,
	"black-2": `df8ngAhNdE`,
	"black-3": `QvXCwhKjTK`,
	"black-4": `KRnbkeGVlY`,
	"black-5": `cZJJIsAoa6`,
	"black-6": `vMY90Sfczy`,
	"picker-theme": `GAwZNJkHZ3`,
	"arrow-regular": `X8y0e6qDnJ`,
	"review-select": `aIyvNsTiqT`,
	"review-select__label": `GG9OuxfbGm`,
	"review-select__root": `IUAuuOKuxO`,
	"review-select__menuCtn": `oTQkrBtGmX`,
	"review-select__selectContainer": `XRzrAwLA_h`
};
export default ___CSS_LOADER_EXPORT___;
